export const LEGAL_PAGES = {
  notice: "/legal/aviso-legal.html",
  privacy: "/legal/privacidad.html",
  cookies: "/legal/cookies.html",
} as const;
